import { motion } from "framer-motion";
import useIsMobile from "hooks/useIsMobile";
import Lottie from "lottie-react";
import { useState } from "react";
import Truck from "../../assets/lotties/truck.json";
import c1010 from "../../images/C1010_azul.png";
import "./LoadingComponent.css";

function LoadingComponent() {
	const [imageLoaded, setImageLoaded] = useState(false);
	return (
		<motion.div
			key="LoadingComponent"
			layout
			initial={{ opacity: 0 }}
			animate={{ opacity: imageLoaded ? 1 : 0 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.15 }}
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "flex-start",
				width: "100%",
				height: "100%",
				overflow: "auto",
				paddingTop: "24px",
			}}
		>
			<motion.div
				layout
				style={{
					maxHeight: "30%",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					maxWidth: "200px",
					minHeight: "115px",
				}}
			>
				<motion.img
					src={c1010}
					onLoad={() => {
						setImageLoaded(true);
					}}
					alt="Carregando"
					style={{
						maxWidth: "100%",
						height: "100%",
						objectFit: "contain",
					}}
				/>
			</motion.div>
			<motion.div
				layout
				style={{
					width: "100%",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					flexDirection: "column",
				}}
			>
				<Lottie
					animationData={Truck}
					loop
					autoplay
					style={{
						width: "100%",
						maxWidth: useIsMobile(768) ? "50%" : "20%",
					}}
				/>
				<span
					style={{
						fontSize: "1.4rem",
						fontWeight: "bold",
					}}
				>
					Carregando...
				</span>
			</motion.div>
		</motion.div>
	);
}

export default LoadingComponent;
